module.exports = __webpack_public_path__ + "img/VRP-logo-horizontal.68666f13.svg";